import * as React from "react";

import {cs} from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";

import {ImageFieldCreator} from "./imageFieldCreator";
import {CustomizationTile} from "./customizationTile";
import {GetImageQuality}     from "@Common/ui-components/photo-dashboard/utils/get-image-quality";

export const Photos = ({orderId, photoData, domRef, updateImage, onApplyImageFromPhotoDashboard = null, onApplyMultipleImagesFromPhotoDashboard, showGallery, imageGuidelinesModal, allowedGalleryTabs, editable, listing = null, setUnsavedChanges}) => cs(
    consumeContext("apis"),
    consumeContext("templateOptions"),
    ["photoQualitySettings", ({templateOptions}, next) => next(templateOptions.photoQualitySettings)],
    ["updatePhotoDataWithListingPhotos", ({apis, photoQualitySettings}, next) => Load2({
        fetch: async() => {
            if (Object.keys(listing).length !== 0) {
                let images = await apis.next.gallery.orders.getImages(orderId);

                // Rename properties of order image data to match those needed for image fields
                for (let image of images) {
                    delete Object.assign(image, {["idPrimary"]: image["id"] })["id"];
                    delete Object.assign(image, {["imageUrl"]: image["printUrl"] })["printUrl"];
                    delete Object.assign(image, {["thumbnail"]: image["thumbnailUrl"] })["thumbnailUrl"];
                    let imageQuality = GetImageQuality({imageInfo: image, photoQualitySettings: photoQualitySettings});
                    image["photoQuality"] = imageQuality;
                }

                // Assign order images to photo fields
                for (let i = 0; i < photoData.length; i++) {
                    photoData[i].data = images[i];
                }

                for (let image of photoData) {
                    await updateImage(orderId, {[image.idPrimary]: image.data.idPrimary});
                }
            }
        },
        next
    })],

    ({}) =>
        <CustomizationTile
            domRef={domRef}
            header="Photos"
            imageGuidelinesModal={imageGuidelinesModal}
            imageType="photo"
            photoCount={photoData.length}
            multiSelectOptions={{showGallery, onApplyMultipleImagesFromPhotoDashboard, allowedGalleryTabs}}
            xdQaName="Photos"
        >
            <ImageFieldCreator
                orderId={orderId}
                data={photoData}
                imageType={"photo"}
                updateImage={updateImage}
                showGallery={showGallery}
                onApplyImageFromPhotoDashboard={onApplyImageFromPhotoDashboard}
                editable={editable}
                allowedGalleryTabs={allowedGalleryTabs}
                setUnsavedChanges={setUnsavedChanges}
                xdQaName={"Photo"}
            />
        </CustomizationTile>
);